import { Button, Modal, Text } from '@shared/widgets';

interface ISuccessDeletedUserModal {
  show: boolean;
  onClose: () => void;
}

export const SuccessDeletedUserModal = (props: ISuccessDeletedUserModal) => {
  return (
    <Modal isOpen={props.show} onClose={props.onClose} title='' setAutoCloseSeconds={5}>
      <div>
        <Text size='xl'>User has been successfully deleted</Text>
        <Button color='primary' className='mt-8' fullWidth onClick={props.onClose}>
          OK
        </Button>
      </div>
    </Modal>
  );
};
